import { render, staticRenderFns } from "./RetailerChains.vue?vue&type=template&id=207689ec&"
import script from "./RetailerChains.vue?vue&type=script&lang=js&"
export * from "./RetailerChains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports